// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* random bc why not */
/* tablet vertical */
* {
  box-sizing: border-box;
}
body {
  width: 100vw;
  height: 100vh;
}
@media screen and (min-width: 768px) {
  body {
    background-image: none;
    background-color: #cacccf;
    padding-top: 70px;
  }
}
.page {
  margin: 0 auto;
  padding: 15px 15px 45px 15px;
  position: relative;
}
@media screen and (min-width: 768px) {
  .page {
    background-color: #fafafa;
    width: 990px;
    max-width: 95%;
    border-radius: 2px;
    box-shadow: 1px 3px 8px -1px #777c84;
  }
}
.splash-image {
  opacity: 0.5;
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  top: -15px;
}
@media screen and (min-width: 768px) {
  .splash-image {
    position: static;
    display: inline-block;
    width: 510px;
    margin: 30px 0 30px 15px;
    opacity: 1;
    min-width: 0;
    min-height: 0;
    transform: none;
  }
}
@media screen and (min-width: 768px) {
  .content {
    position: absolute;
    top: 90px;
    right: 20px;
    width: 630px;
  }
}
.content-lower {
  display: flex;
  flex-direction: column;
}
.header {
  background-color: rgba(61, 90, 128, 0.8);
  padding: 30px 30px;
  border-radius: 2px;
  color: #ebe5e5;
  margin-bottom: 15px;
}
@media screen and (min-width: 768px) {
  .header {
    padding-top: 45px;
    padding-bottom: 45px;
  }
}
h1 {
  font-size: 48px;
  font-family: 'Damion', cursive;
  font-weight: 500;
  margin-bottom: 30px;
  line-height: 60px;
}
@media screen and (min-width: 768px) {
  h1 {
    font-size: 72px;
  }
}
h2 {
  font-family: 'Hind', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
}
@media screen and (min-width: 768px) {
  h2 {
    font-size: 30px;
  }
}
h3 {
  font-family: 'Hind', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
}
@media screen and (min-width: 768px) {
  h3 {
    font-size: 22px;
  }
}
form {
  display: inline-block;
}
.button-container {
  text-align: center;
}
.button-container .button {
  margin-right: 20px;
}
.button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
  outline: none;
  border: none;
  font-family: 'Hind', sans-serif;
  font-size: 20px;
  text-align: center;
  text-decoration: none;
  vertical-align: top;
  transition: background-color 0.11s ease;
  height: 45px;
  margin: 0 auto 10px auto;
  align-self: center;
}
@media screen and (min-width: 550px) {
  .button + .button {
    margin-left: 10px;
  }
}
.primary-button {
  background-color: #eb7255;
  background-image: linear-gradient(to bottom, rgba(235, 114, 85, 0.25) 0%, #e44722 77%);
  color: #fafafa;
  padding: 0 20px;
  min-width: 200px;
}
@media screen and (min-width: 768px) {
  .primary-button {
    min-width: 180px;
  }
}
.primary-button:hover {
  background-color: #ee6c4d;
}
.secondary-button {
  min-width: 200px;
  background-color: #98c1d9;
  background-image: linear-gradient(to bottom, rgba(224, 251, 252, 0.25) 0%, #98c1d9 77%);
  color: #fafafa;
}
@media screen and (min-width: 550px) {
  .secondary-button {
    width: 150px;
  }
}
.secondary-button:hover {
  background-color: #98c1d9;
}
.about {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  font-family: 'Hind', sans-serif;
  font-size: 16px;
  line-height: 30px;
  align-self: flex-start;
  background-color: white;
  padding: 15px;
  border-radius: 2px;
  margin-top: 15px;
}
@media screen and (min-width: 768px) {
  .about {
    padding: 0;
    background-color: transparent;
  }
}
ul {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Hind', sans-serif;
  font-size: 16px;
  line-height: 30px;
  list-style-type: circle;
}
textarea {
  width: 100%;
  margin-bottom: 30px;
  font-family: 'Hind', sans-serif;
  font-size: 14px;
  line-height: 15px;
  padding: 10px;
  border-color: #cacccf;
}
textarea:focus {
  outline: none;
}
.success-text,
.error-text {
  display: none;
}
.contact-modal {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
}
.contact-modal[hidden] {
  display: none;
}
.contact-modal-backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(30, 25, 74, 0.6);
}
.contact-modal-content {
  position: relative;
  background-color: #fafafa;
  border-radius: 3px;
  box-shadow: 1px 3px 8px -1px #777c84;
  padding: 30px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  font-family: 'Hind', sans-serif;
  font-size: 18px;
  line-height: 30px;
}
.contact-modal-content a {
  color: #3d5a80;
}
`, "",{"version":3,"sources":["webpack://./src/styles.less"],"names":[],"mappings":"AAAA,sBAAsB;AACtB,oBAAoB;AAoBpB;EACE,sBAAA;AAlBF;AAqBA;EACE,YAAA;EACA,aAAA;AAnBF;AAqBE;EAAA;IACE,sBAAA;IACA,yBAAA;IACA,iBAAA;EAlBF;AACF;AAqBA;EACE,cAAA;EACA,4BAAA;EACA,kBAAA;AAnBF;AAqBE;EAAA;IACE,yBAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,oCAAA;EAlBF;AACF;AAqBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;AAnBF;AAqBE;EAAA;IACE,gBAAA;IACA,qBAAA;IACA,YAAA;IACA,wBAAA;IACA,UAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;EAlBF;AACF;AAsBE;EAAA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;EAnBF;AACF;AAsBA;EACE,aAAA;EACA,sBAAA;AApBF;AAuBA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AArBF;AAuBE;EAAA;IACE,iBAAA;IACA,oBAAA;EApBF;AACF;AAuBA;EACE,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AArBF;AAuBE;EAAA;IACE,eAAA;EApBF;AACF;AAuBA;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArBF;AAuBE;EAAA;IACE,eAAA;EApBF;AACF;AAuBA;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArBF;AAuBE;EAAA;IACE,eAAA;EApBF;AACF;AAuBA;EACE,qBAAA;AArBF;AAwBA;EACE,kBAAA;AAtBF;AAqBA;EAGI,kBAAA;AArBJ;AAyBA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uCAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AAvBF;AA0BI;EAAA;IACE,iBAAA;EAvBJ;AACF;AA2BA;EACE,yBAAA;EACA,sFAAA;EAKA,cAAA;EACA,eAAA;EACA,gBAAA;AA7BF;AA+BE;EAAA;IACE,gBAAA;EA5BF;AACF;AA8BE;EACE,yBAAA;AA5BJ;AAgCA;EACE,gBAAA;EACA,yBAAA;EACA,uFAAA;EAKA,cAAA;AAlCF;AAoCE;EAAA;IACE,YAAA;EAjCF;AACF;AAuCE;EACE,yBAAA;AArCJ;AAyCA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAxCF;AA0CE;EAAA;IACE,UAAA;IACA,6BAAA;EAvCF;AACF;AA0CA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAxCF;AA2CA;EACE,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;AAzCF;AA2CE;EACE,aAAA;AAzCJ;AA6CA;;EAEE,aAAA;AA3CF;AA8CA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA5CF;AA8CE;EACE,aAAA;AA5CJ;AAgDA;EACE,kBAAA;EACA,QAAA;EACA,uCAAA;AA9CF;AAiDA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AA/CF;AAoCA;EAcI,cAAA;AA/CJ","sourcesContent":["@light-grey: #cacccf;\n@white: #fafafa;\n@off-white: #ebe5e5;\n@header-grey: rgba(64, 72, 83, 0.7);\n\n@blue100: rgba(30, 25, 74, 1);\n@blue75: rgba(61, 90, 128, 1);\n@blue50: rgba(152, 193, 217, 1);\n@blue25: rgba(224, 251, 252, 1);\n\n@salmon-light: rgba(235, 114, 85, 1);\n@salmon: rgba(238, 108, 77, 1);\n@salmon-med: rgba(247, 94, 57, 1);\n@salmon-dark: rgba(228, 71, 34, 1);\n\n/* random bc why not */\n@nonmini: ~'screen and (min-width: 550px)';\n\n/* tablet vertical */\n@tablet: ~'screen and (min-width: 768px)';\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  width: 100vw;\n  height: 100vh;\n\n  @media @tablet {\n    background-image: none;\n    background-color: @light-grey;\n    padding-top: 70px;\n  }\n}\n\n.page {\n  margin: 0 auto;\n  padding: 15px 15px 45px 15px;\n  position: relative;\n\n  @media @tablet {\n    background-color: @white;\n    width: 990px;\n    max-width: 95%;\n    border-radius: 2px;\n    box-shadow: 1px 3px 8px -1px #777c84;\n  }\n}\n\n.splash-image {\n  opacity: 0.5;\n  position: fixed;\n  min-width: 100vw;\n  min-height: 100vh;\n  left: 50%; //\n  transform: translateX(-50%); //\n  z-index: -1;\n  top: -15px;\n\n  @media @tablet {\n    position: static;\n    display: inline-block;\n    width: 510px;\n    margin: 30px 0 30px 15px;\n    opacity: 1;\n    min-width: 0;\n    min-height: 0;\n    transform: none;\n  }\n}\n\n.content {\n  @media @tablet {\n    position: absolute;\n    top: 90px;\n    right: 20px;\n    width: 630px;\n  }\n}\n\n.content-lower {\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  background-color: rgba(61, 90, 128, 0.8);\n  padding: 30px 30px;\n  border-radius: 2px;\n  color: @off-white;\n  margin-bottom: 15px;\n\n  @media @tablet {\n    padding-top: 45px;\n    padding-bottom: 45px;\n  }\n}\n\nh1 {\n  font-size: 48px;\n  font-family: 'Damion', cursive;\n  font-weight: 500;\n  margin-bottom: 30px;\n  line-height: 60px;\n\n  @media @tablet {\n    font-size: 72px;\n  }\n}\n\nh2 {\n  font-family: 'Hind', sans-serif;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 30px;\n\n  @media @tablet {\n    font-size: 30px;\n  }\n}\n\nh3 {\n  font-family: 'Hind', sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 30px;\n\n  @media @tablet {\n    font-size: 22px;\n  }\n}\n\nform {\n  display: inline-block;\n}\n\n.button-container {\n  text-align: center;\n  .button {\n    margin-right: 20px;\n  }\n}\n\n.button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 3px;\n  outline: none;\n  border: none;\n  font-family: 'Hind', sans-serif;\n  font-size: 20px;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: top;\n  transition: background-color 0.11s ease;\n  height: 45px;\n  margin: 0 auto 10px auto;\n  align-self: center;\n\n  + .button {\n    @media @nonmini {\n      margin-left: 10px;\n    }\n  }\n}\n\n.primary-button {\n  background-color: @salmon-light;\n  background-image: linear-gradient(\n    to bottom,\n    fade(@salmon-light, 25%) 0%,\n    @salmon-dark 77%\n  );\n  color: @white;\n  padding: 0 20px;\n  min-width: 200px;\n\n  @media @tablet {\n    min-width: 180px;\n  }\n\n  &:hover {\n    background-color: @salmon;\n  }\n}\n\n.secondary-button {\n  min-width: 200px;\n  background-color: @blue50;\n  background-image: linear-gradient(\n    to bottom,\n    fade(@blue25, 25%) 0%,\n    @blue50 77%\n  );\n  color: @white;\n\n  @media @nonmini {\n    width: 150px;\n  }\n\n  @media @tablet {\n    // width: 180px;\n  }\n\n  &:hover {\n    background-color: @blue50;\n  }\n}\n\n.about {\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 30px;\n  font-family: 'Hind', sans-serif;\n  font-size: 16px;\n  line-height: 30px;\n  align-self: flex-start;\n\n  background-color: white;\n  padding: 15px;\n  border-radius: 2px;\n  margin-top: 15px;\n\n  @media @tablet {\n    padding: 0;\n    background-color: transparent;\n  }\n}\n\nul {\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n  font-family: 'Hind', sans-serif;\n  font-size: 16px;\n  line-height: 30px;\n  list-style-type: circle;\n}\n\ntextarea {\n  width: 100%;\n  margin-bottom: 30px;\n  font-family: 'Hind', sans-serif;\n  font-size: 14px;\n  line-height: 15px;\n  padding: 10px;\n  border-color: @light-grey;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.success-text,\n.error-text {\n  display: none;\n}\n\n.contact-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n\n  &[hidden] {\n    display: none;\n  }\n}\n\n.contact-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background-color: rgba(30, 25, 74, 0.6);\n}\n\n.contact-modal-content {\n  position: relative;\n  background-color: @white;\n  border-radius: 3px;\n  box-shadow: 1px 3px 8px -1px #777c84;\n  padding: 30px;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  font-family: 'Hind', sans-serif;\n  font-size: 18px;\n  line-height: 30px;\n\n  a {\n    color: @blue75;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
